import React from 'react';

type Variant = 'primary' | 'secondary' | 'ghost';
type Size = 'sm' | 'md' | 'lg';

const variantClass: Record<Variant, string> = {
  primary: 'bg-brand-secondary text-white hover:opacity-90 active:opacity-80',
  secondary:
    'bg-surface-card text-text-primary border border-gray-200 hover:bg-gray-100 active:bg-gray-200',
  ghost: 'bg-transparent text-brand-secondary hover:bg-brand-secondary-soft',
};

const sizeClass: Record<Size, string> = {
  sm: 'text-label py-2 px-3',
  md: 'text-body py-3 px-4',
  lg: 'text-body-lg py-4 px-6 font-semibold',
};

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  size?: Size;
};

export const Button: React.FC<Props> = ({
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  ...rest
}) => (
  <button
    {...rest}
    className={[
      'rounded-full inline-flex items-center justify-center gap-2 transition-base disabled:opacity-50 disabled:cursor-not-allowed font-sans font-semibold',
      variantClass[variant],
      sizeClass[size],
      className,
    ]
      .filter(Boolean)
      .join(' ')}
  >
    {children}
  </button>
);
